import {
  RECEIVE_BANNERS,
  FETCH_BANNERS,
  SET_BANNERS_ERRORS,
} from '../constants';
import { createReducer } from '../utils/misc';

const initialState = {
    errors: {},
    fetching: {},
    banners: {},
};

export default createReducer(initialState, {
  [RECEIVE_BANNERS]: (state, payload) => {
    const { bannerCode, bannerValue } = payload;
    const newFetching = { ...state.fetching };
    const newErrors = { ...state.errors };
    delete newFetching[bannerCode];
    delete newErrors[bannerCode];
    return {
      ...state,
      banners: { ...state.banners, [bannerCode]: bannerValue },
      fetching: newFetching,
      errors: newErrors,
    };
  },
  [FETCH_BANNERS]: (state, payload) => {
    const { bannerCode } = payload;
    const newBanners = { ...state.banners };
    const newErrors = { ...state.errors };
    delete newBanners[bannerCode];
    delete newErrors[bannerCode];
    return {
      ...state,
      fetching: { ...state.fetching, [bannerCode]: true },
      banners: newBanners,
      errors: newErrors,
    };
  },
  [SET_BANNERS_ERRORS]: (state, payload) => {
    const { bannerCode, bannerError } = payload;
    const newFetching = { ...state.fetching };
    delete newFetching[bannerCode];
    return {
      ...state,
      errors: { ...state.errors, [bannerCode]: bannerError },
      fetching: newFetching,
      banners: { ...state.banners },
    };
  }
});
